import React, {useContext, useEffect, useState} from "react";
import {DynamicComponentProps} from "../../core/_models";
import {Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select} from "@mui/material";
import {Badge} from "react-bootstrap";

export function MultiselectComponent({config, context}: DynamicComponentProps) {
    const {title, data, id, value, onChange: action} = config;

    const [v, setValue] = useState(value);
    const formContext = useContext(context);

    useEffect(() => {
        formContext.set(id, v)
    }, [value])

    const label = title || 'Select'

    return (
        <FormControl fullWidth={true}>
            <InputLabel htmlFor="select-multiple-checkbox">{label}</InputLabel>
            <Select
                fullWidth={true}
                multiple
                size='small'
                variant="outlined"
                value={v}
                //onChange={handleChange}
                onChange={(e) => {
                    setValue(e.target.value)
                    formContext.set(id, e.target.value)

                    if (action != null) {
                        formContext.submit({action})
                    }
                }}
                input={<OutlinedInput id="select-multiple-checkbox" size='small' label={label}/>}
                renderValue={selected => (
                    <div>
                        {(selected as any[]).map(value => {
                            const item = (data as { id: any, name: string }[]).filter(x => x.id === value);

                            return <Badge bg="primary" className="text-white me-2">{item[0]?.name || value}</Badge>
                        })}
                    </div>
                )}
                //MenuProps={MenuProps}
            >
                {(data as { id: any, name: any }[]).map(option => (
                    <MenuItem key={`${title}-${option.id}`} value={option.id}>
                        <Checkbox checked={v.indexOf(option.id) > -1}/>
                        <ListItemText primary={option.name}/>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}